import styled from "@emotion/styled";
import { Grid2 } from "@mui/material";

const Item = styled(Grid2)`
  margin-bottom: ${p => p.theme.space[0]};

  background-color: ${p => (p.isactive ? p.theme.colors.background : "")};
  border-radius: ${p => p.theme.radii.medium};
  transition: background-color 0.3s ease-in-out;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    margin-bottom: ${p => p.theme.space[5]}px;
  }

  svg {
    fill: ${props => props.theme.colors.black};
    transition: fill 0.3s ease;
  }

  [data-ip="icons"] {
    transition: background-color 0.3s ease;
  }

  :hover,
  :active {
    [data-ip="icons"] {
      background-color: ${props => props.theme.colors.black};

      svg {
        fill: ${props => props.theme.colors.accent.green};
      }
    }
  }

  &:hover {
    background-color: ${props => props.theme.colors.background};
  }

  &:active {
    background-color: ${props => props.theme.colors.secondary.active};
  }

  & a {
    display: block;
    padding: ${p => p.theme.space[4]}px;
  }
`;

const WrapperRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    flex-direction: row;
    align-items: center;
  }
`;

const WrapperOne = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${p => p.theme.space[2]}px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    margin-bottom: ${p => p.theme.space[0]};
  }
`;

const WrapperTwo = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;

  font-size: 20px;
  font-weight: 500;
  line-height: 1;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    width: auto;
    min-width: 120px;
    margin-top: ${p => p.theme.space[0]};
    flex-direction: column;
    align-items: flex-start;
    font-size: 24px;
  }
`;

const WrapperPrice = styled.div`
  display: flex;
  align-items: center;
`;

const TextOne = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.secondary.popular_queries};
  margin-top: 4px;
  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    ${({ isTools }) => !isTools && "padding-right: 15px;"}
    ${({ isTools }) => !isTools && "max-width: 335px;"}
  }
`;

const TextTwo = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  display: ${({ price }) => (price === "0" ? "none" : "block")};
  color: ${({ theme }) => theme.colors.secondary.popular_queries};
`;

const Dollar = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  align-self: start;
  margin-right: ${p => p.theme.space[2]}px;
`;

const Price = styled.span`
  margin-right: ${p => p.theme.space[1]}px;
`;

const Month = styled.span`
  font-size: 14px;
  font-weight: 300;
  line-height: 1.15;
  align-self: end;
  color: ${({ theme }) => theme.colors.secondary.popular_queries};
`;

const StyledImg = styled.img`
  border-radius: 5px;
`;
export {
  Item,
  WrapperRoot,
  WrapperOne,
  WrapperTwo,
  WrapperPrice,
  TextOne,
  TextTwo,
  Dollar,
  Price,
  Month,
  StyledImg,
};
